/*###########################################################################
// Third party
//#########################################################################*/

import consoleMessage from './utilities/_console'

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initThirdParties, 3500)
})
document.addEventListener('scroll', initThirdPartiesOnEvent)
document.addEventListener('mousemove', initThirdPartiesOnEvent)
document.addEventListener('touchstart', initThirdPartiesOnEvent)

function initThirdPartiesOnEvent(event) {
  initThirdParties()
  event.currentTarget.removeEventListener(event.type, initThirdPartiesOnEvent);
}

function initThirdParties() {
  if (window.thirdPartiesDidInit) {
    return false
  }

  window.thirdPartiesDidInit = true

	// Init GTM
	//
	if (document.documentElement.hasAttribute('data-gtm-id')) {
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = true
		script.onload = () => {
			dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime(), 'gtm.uniqueEventId': 0 })
		}
		script.src = 'https://www.googletagmanager.com/gtm.js?id=' + document.documentElement.getAttribute('data-gtm-id')
		document.head.appendChild(script)

    consoleMessage("GTM loaded: " + document.documentElement.getAttribute('data-gtm-id'))
	}
}
